export const GET_SPEECH_REQUESTED = 'GET_SPEECH_REQUESTED'
export const GET_SPEECH_SUCCESS = 'GET_SPEECH_SUCCESS'
export const GET_SPEECH_FAILURE = 'GET_SPEECH_FAILURE'

export const SOURCE_TYPE = {
  TRANSCIRPTION: 'speechToText',
  PHONETICS: 'phonetics',
} as const
